import {useState, useEffect} from 'react';
import { useSession } from "../../context/SessionContext";
import  Button  from '@mui/material/Button';
import {features, modules, LicenceTypes} from "../../data/ControlledLists";
import {CSVString2Array, Array2CSVString} from "../../Utilities/Utilities";
import { useAuthContext } from '../../context/AuthContext';
import { useLoginServer } from '../../context/LoginServerContext';
import CustomFieldsMetadata from '../../data/CustomFieldsMetadata';
import { KamsModuleList, KamsExpressModuleList, KamsGolfModuleList, KamsGolfExpressModuleList, KamsIlModuleList, KamsJoint3DModuleList, ROFWorkflowModuleList} from '../../data/ControlledLists';
import LicenceUpdateModFeaturesInformation from './LicenceUpdateModFeaturesInformation';
import LicenceData from '../../data/LicenceData';
import ValidateListDialog from '../dialogs/ValidateListDialog';
import WarningYesNoDialog from '../dialogs/WarningYesNoDialog';
import InfoOkDialog from '../dialogs/InfoOkDialog';
import SuccessOkDialog from '../dialogs/SuccessOkDialog';
import ErrorOkDialog from '../dialogs/ErrorOkDialog';
import { mainFeatures, correctivesFeatures, WorkflowAssessmentList} from '../../data/ControlledLists';

const LicenceUpdateModFeaturesEdit = ({}) => {

    const [row, setRow] = useState(LicenceData);
    const [organizations, setOrganizations] = useState([]);
    const [errorMessage, setErrorMessage] = useState(false);
    const [savedMessage, setSavedMessage] = useState(false);
    const [message, setMessage] = useState("");
    const [alertState, setAlertState] = useState({success: false, error: false, warning: false, info: false});
    const session = useSession();
    const loginServerURL = useLoginServer();
    const {currentToken} = useAuthContext();
    const [allFeatures, setAllFeatures] = useState([]);
    const [branding, setBranding] = useState([]);
    const [CFFeatures, setCFFeatures] = useState([]);
    const [flexLicenceTemplates, setFlexLicenceTemplates] = useState([]);
    const [presetWorkflows, setPresetWorkflows] = useState([]);
    const [data, setData] = useState({"type":"", "name":"", "modules":"", "features":""});
    const [displayList, setDisplayList] = useState(false);
    const [list, setList] = useState([]);
    const [title, setTitle] = useState("");
    const [search, setSearch] = useState(false);
    const [searchString, setSearchString] = useState("");
    const [skip, setSkip] = useState(0);
    const [value, setValue] = useState(0);
    const [loading, setLoading] = useState(true);


    // chevy addon
    //const [flexLicenceTemplates, setFlexLicenceTemplates] = useState([]);
    //const [presetWorkflows, setPresetWorkflows] = useState([]);
    const [featuresList, setFeaturesList] = useState([]);
    const [brandingList, setBrandingList] = useState([]);
    const [correctivesList, setCorrectivesList] = useState([]);
    const [presetWorkflowList, setPresetWorkflowList] = useState([]);
    const [cfTemplatesList, setCFTemplatesList] = useState([]);

console.log("Row: ",row);

    // console.log("Search: ",search);
    // console.log("Loading: ",loading);
    // console.log("Title: ",title);
    // console.log("DisplayList: ",displayList);
    // console.log("List:",list);

    useEffect (() => {
        getBrandingFeatures();
        getCustomFieldMetadata();
        getFlexLicenceTemplates();
        getPresetWorkflow();
    },[]);

    useEffect (() => {
        console.log("UseEffect Session: ",session);
        console.log("Search flag: ", search);
        if (search) {
            var ss = "";
            ss = "*empty*";
            let queryString = `?$filter=((id ne null) and (updatedAt ge 1970-01-01T20:00:00Z))&$orderby=updatedAt&$skip=${skip}&top=1000`
            try { 
                let url = session.subscriptionServer + "/tables/subscription/" + queryString;
                console.log("URL: ",url);
                fetch(url, {
                    method: 'GET',
                    headers:{"Content-type":"application/json"}
                }).then ((response) => response.json())
                .then ((data) => {
                    console.log("Licence Data: ",data);
                    setList(list.concat(data));
                    setSkip(skip + data.length);
                    if (data.length === 0) {
                    setLoading(false);
                    setDisplayList(true);
                    setTitle("The following licences will be updated");
                    }
                }).catch ((error) => {
                    console.log(error);
                });  
            } catch(err) {
                console.log(err);
            }
        }
    },[search, skip]);
  
    const getCustomFieldMetadata = () => {
        var rows = [CustomFieldsMetadata];
        let queryString = `?$filter=((id ne null) and (updatedAt ge 1970-01-01T20:00:00Z))&$orderby=updatedAt&$skip=0&top=1000`
        fetch(loginServerURL + "/tables/CustomFieldsMetaData" + queryString, {
            method: 'GET',
            headers:{
                "X-ZUMO-AUTH": currentToken,
                "Content-type":"application/json"
            }
        }).then ((response) => response.json())
        .then ((data) => {
            rows = data.filter((r) => r.isDeleted === false);
            var list = [];
            rows.forEach((p) => {
                list.push(p.featureName);
            });
            setCFFeatures(list);
        }).catch ((error) => {
            console.log("MD Error: ",error);
        });  
    }

    function getFlexLicenceTemplates () {
        let queryString = `?$filter=((id ne null) and (updatedAt ge 1970-01-01T20:00:00Z))&$orderby=updatedAt&$skip=0&top=1000`
        console.log("queryData: ",queryString)
      try { 
        fetch(session.subscriptionServer + "/tables/FlexLicenceTemplate/" + queryString, {
            method: 'GET',
            headers:{"Content-type":"application/json"}
        }).then ((response) => response.json())
        .then ((data) => {
          setFlexLicenceTemplates(data);
          
        }).catch ((error) => {
            console.log(error);
        });  
      } catch(err) {
        console.log(err);
      }
    }

    function getBrandingFeatures () {
        fetch(session.subscriptionServer + "/api/GetBrandingList" , {
            method: 'GET',
            headers:{
                "X-ZUMO-AUTH": currentToken,
                "Content-type":"application/json"
            }
        }).then ((response) => response.json())
        .then ((data) => {
            setBranding(data); 
        }).catch ((error) => {
            console.log("BrandingError Error: ",error);
            return [];
        });  
    }
    function getPresetWorkflow () {
        let queryString = `?$filter=((id ne null) and (updatedAt ge 1970-01-01T20:00:00Z))&$orderby=updatedAt&$skip=0&top=1000`
        fetch(loginServerURL + "/tables/PresetWorkflow" + queryString, {
            method: 'GET',
            headers:{
                "X-ZUMO-AUTH": currentToken,
                "Content-type":"application/json"
            }
        }).then ((response) => response.json())
        .then ((data) => {
            setPresetWorkflows(filterPresetWorkflowList(data)); 
        }).catch ((error) => {
            console.log("PresetWorkflow Error: ",error);
            return [];
        });  
    }

    const filterPresetWorkflowList = (data) => {
        let list = data.filter((r) => r.isDeleted === false && r.kinetisensePresetWorkflow === true);
        return list.map((a) => ({name: a.name, assessmentTypesString: a.assessmentTypesString, associatedCFTemplate: a.associatedCFTemplate}));
    }

    const handleUpdate = async (e) => {
        e.preventDefault();
        console.log("Save");
         try { 
            fetch(session.subscriptionServer + "/tables/subscription/" + row.id, {
                method: 'PATCH',
                body: JSON.stringify(row),
                headers:{"Content-type":"application/json"}
            }).then ((response) => response.json())
            .then ((data) => {
                setRow(data);
                console.log("Updated: ",data);
                setSavedMessage(true);
            }).catch ((error) => {
                console.log(error);
                setErrorMessage(true);
            });  
        } catch(err) {
          console.log(err);
        }

      };
    
      const handleFieldUpdate = (event, newValue, id) => {
        console.log("Case: ",id,  newValue)
        setErrorMessage(false);
        setSavedMessage(false);
        const updatedDate = Date.UTC;
        if (id ==='name') {
            setData({...data, name: newValue})
        } else if (id ==='type') {
            setData({...data, type: newValue})
        } else if (id ==='modules') {
            setData({...data, modules: Array2CSVString(newValue)})
        } else if (id ==='features') {

            // chevy addon
            setFeaturesList(newValue);
                        // rebuild the fearures list
                        // setRow({...row, features: Array2CSVString(newValue.concat(brandingList).concat(correctivesList).concat(cfTemplatesList).concat(presetWorkflowList).sort((a, b) => (a > b ? 1 : -1))), updatedAt: updatedDate  })
                        setData({...data, features: Array2CSVString(newValue.concat(brandingList).concat(correctivesList).concat(cfTemplatesList).concat(presetWorkflowList).sort((a, b) => (a > b ? 1 : -1))), updatedAt: updatedDate  })
                    } else if (id ==='cfTemplates') {
                        setCFTemplatesList(newValue);
                        // setRow({...row, features: Array2CSVString(featuresList.concat(brandingList).concat(correctivesList).concat(newValue).concat(presetWorkflowList).sort((a, b) => (a > b ? 1 : -1))), updatedAt: updatedDate  })
                        setData({...data, features: Array2CSVString(featuresList.concat(brandingList).concat(correctivesList).concat(newValue).concat(presetWorkflowList).sort((a, b) => (a > b ? 1 : -1))), updatedAt: updatedDate  })
                    } else if (id ==='branding') {
                        setBrandingList(newValue);
                        // setRow({...row, features: Array2CSVString(featuresList.concat(newValue).concat(correctivesList).concat(cfTemplatesList).concat(presetWorkflowList).sort((a, b) => (a > b ? 1 : -1))), updatedAt: updatedDate  })
                        setData({...data, features: Array2CSVString(featuresList.concat(newValue).concat(correctivesList).concat(cfTemplatesList).concat(presetWorkflowList).sort((a, b) => (a > b ? 1 : -1))), updatedAt: updatedDate  })
                    } else if (id ==='correctives') {
                        setCorrectivesList(newValue);
                        // setRow({...row, features: Array2CSVString(featuresList.concat(brandingList).concat(newValue).concat(cfTemplatesList).concat(presetWorkflowList).sort((a, b) => (a > b ? 1 : -1))), updatedAt: updatedDate  })
                        setData({...data, features: Array2CSVString(featuresList.concat(brandingList).concat(newValue).concat(cfTemplatesList).concat(presetWorkflowList).sort((a, b) => (a > b ? 1 : -1))), updatedAt: updatedDate  })
                    } else if (id ==='presetWorkflows') {
                        var list = data.modules;
                        setPresetWorkflowList(newValue);
                        var newFeatures = newValue;
                        var newcfTemplatesList = cfTemplatesList;
            // console.log("New Features: ",newFeatures);
            
                        newFeatures.forEach((f) => {
                            console.log("Feature: ",f);
                          
            
                            // new way to add the modules
                            var workflow = presetWorkflows.filter((r) => r.name === f);
                            // console.log("Workflow: ",workflow);
                            if (workflow.length > 0) {
                               
                                var types = workflow[0].assessmentTypesString.split(",");
                                // console.log("Types: ",types);
                                types.forEach((m) => {
                                    if (list !== "") {
                                        list = list.concat(",");
                                    }
                                    // console.log("M: ",m);
                                    // console.log("WorkflowAssessmentList: ",WorkflowAssessmentList);
                                    list = list.concat(WorkflowAssessmentList.filter((r) => r.name === m).map(a => a.module));
                                    // console.log("List: ",list);
                                }) 
                                if (
                                    workflow[0].associatedCFTemplate !== null &&
                                    workflow[0].associatedCFTemplate !== "" &&
                                    !newcfTemplatesList.includes(workflow[0].associatedCFTemplate)
                                ) {
                                    newcfTemplatesList.push(workflow[0].associatedCFTemplate);
                                    setCFTemplatesList(newcfTemplatesList);
                                }                
                            }
                        });
            
                        var newModules = Array2CSVString([...new Set((CSVString2Array(list)))]);
                        console.log("Modules:",newModules)
                        // setRow({...row, features: Array2CSVString(featuresList.concat(brandingList).concat(correctivesList).concat(newcfTemplatesList).concat(newFeatures)), modules: newModules, updatedAt: updatedDate });
                        setData({...data, features: Array2CSVString(featuresList.concat(brandingList).concat(correctivesList).concat(newcfTemplatesList).concat(newFeatures)), modules: newModules, updatedAt: updatedDate });
                        //var newModules = Array2CSVString([...new Set((CSVString2Array(list)))]);
            
                        //setRow({...row, features: Array2CSVString(newValue), modules:newModules, updatedAt: updatedDate  });
                    }  else {
                        console.log("Missing: ",id)
                    }
                  }

        
    const handleChange = (e, newValue) => {
        e.preventDefault();
        setSearch(true);
    }
    
    const handleDisplayListClose = () => {
        setDisplayList(false);
        setList([]);
        setTitle("");
        setSearch(false);
        setSkip(0);
        setData({"type":"", "name":"", "modules":"", "features":""});
    }

    // filter the list based on the selection
    const filterLicenceList = () => {
        var newData = null;
        if (data.type !== "") {
            newData =  list.filter((r) => r.isDeleted === false && r.name === data.type && r.displayName === data.name);
        } else {
            newData =  list.filter((r) => r.isDeleted === false);
        }
        return newData;
    }

    const handleProceedWithUpdate = () => {
        console.log("Proceed with update")
        setDisplayList(false);
        setTitle("");
        setSearch(false);
        setSkip(0);
        let list = filterLicenceList();
        list.forEach((r) => {
            var row = r;
            var m= CSVString2Array(row.modules);
            var listm = m.concat(CSVString2Array(data.modules)).sort((a, b) => (a > b ? 1 : -1));
            row.modules = Array2CSVString([...new Set(listm)])
            var f=CSVString2Array(row.features);
            var listf = f.concat(CSVString2Array(data.features)).sort((a, b) => (a > b ? 1 : -1));
            row.features = Array2CSVString([...new Set(listf)])

            console.log("Row: ",row);
            try { 
                fetch(session.subscriptionServer + "/tables/subscription/" + r.id, {
                    method: 'PATCH',
                    body: JSON.stringify(row),
                    headers:{"Content-type":"application/json"}
                }).then ((response) => {
                    if(response.status>= 200 && response.status < 300){
                      return response.json();
                    } else {
                      throw new Error(response.status);
                    }
                }).catch ((error) => {
                    console.log(error);
                    setErrorMessage(true);
                });  
            } catch(err) {
              console.log(err);
            }
        });
        setAlertState({success: true, error: false, warning: false, info: false});
        setMessage("Licences Updated");
    }  
    
    const handleCloseDisplayMessage = () => {
        setAlertState({success: false, error: false, warning: false, info: false});
        setMessage("");
        handleDisplayListClose();
    }
    
    const handleWarningDialogNo = () => {
        setAlertState({success: false, error: false, warning: false, info: false});
        setMessage("");
        handleDisplayListClose();
    }

    const handleErrorDialogClose = () => {
        setAlertState({success: false, error: false, warning: false, info: false});
        setMessage("");
    }

    const handleDisplayConfirmationDialog = () => {
        setAlertState({success: false, error: false, warning: true, info: false});
        setMessage("Are you sure you want to update the licences? There is no UNDO to this action.");
    }

     const featureList = () => {
            let result = new Set((CFFeatures.concat(features).concat(branding).concat(presetWorkflows)));
            result = [...result].sort((a, b) => (a > b ? 1 : -1));
            return result;
        }

    //chevy addon
        const filterFeatureList = (features, list) => {
        // console.log("Features: ",features);
        // console.log("List: ",list);
        let filteredList = [];
        features.forEach((f) => {
            list.forEach((l) => {
                if (f === l) {
                    filteredList.push(l);
                }
            })
        })
        // console.log("Filtered List: "+list, filteredList);
        return filteredList.sort((a, b) => (a > b ? 1 : -1));
    }

    return (
        <>
            <SuccessOkDialog open={alertState.success} message={message} handleClose={handleCloseDisplayMessage}/>
            <ErrorOkDialog open={alertState.error} message={message} handleClose={handleErrorDialogClose} />
            <WarningYesNoDialog open={alertState.warning} message={message} handleNo={handleWarningDialogNo} handleYes={handleProceedWithUpdate} />
           
            <ValidateListDialog 
                list={filterLicenceList()} 
                handleClose = {handleDisplayListClose} 
                open={displayList} 
                title={title} 
                handleOk = {handleDisplayConfirmationDialog}
            />
            <form onSubmit={handleChange}>
                <div className="formInput" style={{width: "700px", marginLeft: "20px"}}>
                
                    <LicenceUpdateModFeaturesInformation 
                        data={data}
                        baseModules={modules}
                        baseFeatures={featureList()}
                        onFieldChange={(event,value, id) => handleFieldUpdate(event, value, id)}
                        flexLicenceTemplates={flexLicenceTemplates}
                        licenceTypes={LicenceTypes}
                        mainFeatures={mainFeatures}
                        CFFeatures={CFFeatures}
                        branding={branding}
                        presetWorkflows={presetWorkflows}
                        correctivesFeatures={correctivesFeatures}
                        selectedMainFeatures={featuresList}
                        selectedCFFeatures={cfTemplatesList}
                        selectedBranding={brandingList}
                        selectedPresetWorkflows={presetWorkflowList}
                        selectedCorrectivesFeatures={correctivesList}
                    />
                        
                    <div className="formButtons" >
                        <div className="left">
                            {errorMessage && <div className="error">An error occured</div>}
                            {savedMessage && <div className="message">Licence Saved</div>}
                        </div>
                        <div className="right">
                            <Button  
                                type="submit"
                                variant="contained"
                                className="button"
                            >
                                Update
                            </Button>
                            
                        </div>
                    </div>
                </div>
            </form>
      </>      
    );
}

export default LicenceUpdateModFeaturesEdit;